import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M16.44 13.34H18V16.18C18 17.19 17.18 18.01 16.17 18.01H7.83C6.82 18.01 6 17.19 6 16.18V7.83C6 6.82 6.82 6 7.83 6H10.43V7.57H7.57V16.44H16.45V13.34H16.44ZM12.26 6V7.58H15.31L11.12 11.8L12.23 12.92L16.42 8.7V11.74H18V6H12.26Z" fill={ fill || 'currentColor' } />
    </svg>
);
